import Badge from 'client/components/core/Badge'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { typedPageSelectors, usePage } from 'client/store'
import CommonBlogPostDate from 'common/components/entities/BlogPostDate/BlogPostDateNew'
import { BlogPostDateInterface } from 'common/types/entities/BlogPostDateInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EntityProps } from '../../../types'

const date = new Date()

function BlogPostDateNew({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BlogPostDateInterface>) {
  const locale = usePage(typedPageSelectors.getPageLocale)
  const { t } = useTranslation()

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <>
        <CommonBlogPostDate
          date={date}
          locale={locale}
          attrId={entity.htmlAttrId}
          fontSize={entity.fontSize}
          fontFamily={entity.fontFamily}
          fontStyle={entity.fontStyle}
          fontWeight={entity.fontWeight}
          mobileFontSize={entity.mobileFontSize}
          mobileFontFamily={entity.mobileFontFamily}
          mobileFontStyle={entity.mobileFontStyle}
          mobileFontWeight={entity.mobileFontWeight}
          lineHeight={entity.lineHeight}
          mobileLineHeight={entity.mobileLineHeight}
          color={entity.color}
          mobileColor={entity.mobileColor}
          alignSelf={entity.alignSelf}
          mobileAlignSelf={entity.mobileAlignSelf}
        />
        <Badge wide>
          {t('entities.blog_post_date.warnings.do_not_remove')}
        </Badge>
      </>
    </BaseEntityNew>
  )
}

export default BlogPostDateNew
